import React from 'react';
import { DateTime } from 'luxon';

const ConfirmationHeader = ({application}) => {
    return (
        <div className="d-flex justify-content-md-center flex-column">
        <h4 className="text-start">
            Zip code: {application.page1['zipCode']}{' '}
            - {application.page2['plan']} -
            Effective Date:{' '}
            {DateTime.fromISO(
                application.page4.sub2[
                    'proposedEffectiveDate'
                ]
            ).toFormat('MM/dd/yyyy')}{' '}
            -
            <strong>
                {' '}
                {
                    application.page4.sub2[
                        'firstName'
                    ]
                }{' '}
                {application.page4.sub2['lastName']}
            </strong>
        </h4>
        <hr />
    </div>
    )
}

export default ConfirmationHeader;